@if ({ data: displayData$ | async, translations: translations$ | async, listLoader: listLoader$ | async }; as $) {
    <adspt-selector-button
        [ngClass]="{ 'disabled-close': disableReset, 'multi-selector': $.data.multpleSelections }"
        nz-dropdown
        nzTrigger="click"
        [(nzVisible)]="isVisible"
        [nzDropdownMenu]="menu"
        [nzClickHide]="false"
        adsptHeap="account-global-selector"
        [heapDisabled]="isVisible"
        [showLoader]="loader$ | async"
        [defaultLabel]="$.translations.title"
        [hideFloatingLabel]="hideFloatingLabel"
        [showDefaultLabel]="$.data.src.type === 'LABEL'"
        [label]="$.data.src.payload || $.translations.title"
        [selectionLabels]="$.data.labels.buttonTexts"
        [tooltip]="$.data.labels.tooltip"
        [isOpen]="isVisible"
        [logo]="$.data.src?.payload?.logo"
        [disableCloseIcon]="disableCloseIcon"
        (closed)="reset.emit({})"
        (nzVisibleChange)="onDropDownVisibiltiyChange($event)"
    />
    <nz-dropdown-menu #menu="nzDropdownMenu">
        @if (isVisible) {
            <div class="dialog-wrapper">
                <adspt-global-selector-dialog-content
                    [isVisible]="isVisible"
                    [hasDestinationSelector]="false"
                    [selectedTabIndex]="selectedTabIndex"
                    [enableAdvancedMode]="enableAdvancedMode"
                    [enableAdvancedFilterSelection]="enableAdvancedFilterSelection"
                    [subfilterOptions]="subfilterOptions"
                    [obs]="$"
                    [rowItemTmpl]="rowItemTmpl"
                    [srcList]="srcList$"
                    [srcTotalCount]="srcTotalCount$"
                    [hasSrcQuery]="hasSrcQuery$"
                    [heapInfo]="heapInfo"
                    (selectedTabIndexChange)="selectedTabIndex = $event"
                    (notfiy)="onNotifications($event.evt, $event.filterMode)"
                    (refinerChange)="onRefinerChange($event.evt, $event.filterMode)"
                >
                </adspt-global-selector-dialog-content>
            </div>
        }
    </nz-dropdown-menu>
    <ng-template #rowItemTmpl let-data>
        <adspt-account-logo
            class="a-fx-none small-medium"
            [account]="data"
            [nz-tooltip]="data.signupCompleted ? null : ('common.sync-progress' | translate)"
            [showStatus]="!data.signUpCompleted"
        />
        <div class="a-fx a-fx-flex a-fx-between-center a-fx-gap-16">
            <div class="a-fx-flex">
                {{ data.name }} | {{ data.accountId }}
                @for (tag of data.tags; track tag) {
                    <nz-tag class="adspt-tag-light">
                        {{ tag }}
                    </nz-tag>
                }
            </div>
            @if (data.id === $.data.selectedItems[filterMode.Source] && !disableCloseIcon) {
                <svg
                    nz-tooltip
                    [nzTooltipTitle]="'common.remove-selected-item' | translate"
                    class="adspt-icon close-icon a-fx-none"
                    (click)="$event?.stopPropagation(); reset.emit({ tab: filterMode.Source })"
                >
                    <use xlink:href="#adspt-cross-circle"></use>
                </svg>
            } @else {
                @if (isSysAdmin$ | async) {
                    <a
                        class="adspt-icon actions-icon a-fx-none"
                        nz-tooltip
                        [nzTooltipTitle]="'global-filter.account-selector.show-account-details' | translate"
                        adsptExplorerHref="admin/scopes/account/{{ data.id }}/details"
                        (click)="$event?.stopPropagation()"
                    >
                        <svg class="adspt-icon">
                            <use xlink:href="#adspt-open-new-tab"></use>
                        </svg>
                    </a>
                }
            }
        </div>
    </ng-template>
}
